import SigliveServiceV1 from 'Service/sigliveServiceV1';

const postUserAvalaibility = async ({ payload }) => {
  const { data } = await SigliveServiceV1({ method: 'POST', url: `/user/availability`, data: payload });

  return data;
};

export default postUserAvalaibility;
